import { auth } from "../firebase/firebaseConfig";
import { STRIPE_BASE } from "./config";

async function authHeaders() {
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error("Sign in is required.");
  }

  const token = await currentUser.getIdToken();

  return {
    Authorization: `Bearer ${token}`,
  };
}

async function readJson(response) {
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(
      payload?.error || `Discord request failed (${response.status})`
    );

    error.status = response.status;
    throw error;
  }

  return payload;
}

export async function startDiscordConnect() {
  const response = await fetch(`${STRIPE_BASE}/discord/connect`, {
    method: "GET",
    headers: await authHeaders(),
    credentials: "include",
  });

  return readJson(response);
}

export async function getDiscordStatus() {
  const response = await fetch(`${STRIPE_BASE}/discord/status`, {
    method: "GET",
    headers: await authHeaders(),
    credentials: "include",
    cache: "no-store",
  });

  return readJson(response);
}

export async function getDiscordDestinationAction() {
  const status = await getDiscordStatus();
  if (status?.connected === true && status?.destination) {
    return { url: status.destination, connected: true };
  }

  const connect = await startDiscordConnect();
  return { url: connect?.url, connected: false };
}
